import { render, staticRenderFns } from "./Zusammenfassung.vue?vue&type=template&id=10a9068a&scoped=true&"
import script from "./Zusammenfassung.vue?vue&type=script&lang=js&"
export * from "./Zusammenfassung.vue?vue&type=script&lang=js&"
import style0 from "./Zusammenfassung.vue?vue&type=style&index=0&id=10a9068a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10a9068a",
  null
  
)

export default component.exports